import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer bg-black text-white w-full">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-6">
              <img 
                src={`${process.env.PUBLIC_URL}/assets/CrashChampions_Logo_Black.png`} 
                alt="Crash Champions" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-8 text-sm leading-relaxed">
              Together, we're fueling the future of the collision repair industry.
            </p>
            
            {/* Social Media Icons */}
            <div className="flex space-x-3">
              {/* Facebook */}
              <a href="https://www.facebook.com/crashchampions" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors">
                <svg className="w-5 h-5 text-black" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              
              {/* Instagram */}
              <a href="https://www.instagram.com/crashchampions" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors">
                <svg className="w-5 h-5 text-black" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.621 5.367 11.988 11.988 11.988s11.987-5.367 11.987-11.988C24.014 5.367 18.647.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.596-3.205-1.532-.757-.937-1.205-2.187-1.205-3.457s.448-2.52 1.205-3.457c.757-.936 1.908-1.532 3.205-1.532s2.448.596 3.205 1.532c.757.937 1.205 2.187 1.205 3.457s-.448 2.52-1.205 3.457c-.757.936-1.908 1.532-3.205 1.532zm7.718 0c-1.297 0-2.448-.596-3.205-1.532-.757-.937-1.205-2.187-1.205-3.457s.448-2.52 1.205-3.457c.757-.936 1.908-1.532 3.205-1.532s2.448.596 3.205 1.532c.757.937 1.205 2.187 1.205 3.457s-.448 2.52-1.205 3.457c-.757.936-1.908 1.532-3.205 1.532z"/>
                  <rect x="6" y="6" width="12" height="12" rx="3" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <path d="M16.5 7.5h.01"/>
                </svg>
              </a>
              
              {/* LinkedIn */}
              <a href="https://www.linkedin.com/company/crash-champions-llc/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors">
                <svg className="w-5 h-5 text-black" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              
              {/* YouTube */}
              <a href="https://www.youtube.com/@CrashChampions" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors">
                <svg className="w-5 h-5 text-black" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Contact Us */}
          <div className="lg:col-span-1">
            <h3 className="text-xl font-semibold mb-6 text-white">Contact Us</h3>
            <div className="space-y-4 text-gray-300">
              <p className="text-sm">(815) 693-4361 </p>
              <p className="text-sm">charityevent@crashchampions.com</p>
              <p className="text-sm">
                601 Oakmont Lane<br/>
                Westmont, IL 60559
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-1">
            <h3 className="text-xl font-semibold mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-red-600 transition-colors text-sm flex items-center">
                  <span className="w-2 h-2 rounded-full mr-3 flex-shrink-0" style={{backgroundColor: '#e51c22'}}></span>
                  Terms and Conditions
                </Link>
              </li>
              <li>
                <Link to="/liability-waivers" className="text-gray-300 hover:text-red-600 transition-colors text-sm flex items-center">
                  <span className="w-2 h-2 rounded-full mr-3 flex-shrink-0" style={{backgroundColor: '#e51c22'}}></span>
                  Liability Waivers
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-red-600 transition-colors text-sm flex items-center">
                  <span className="w-2 h-2 rounded-full mr-3 flex-shrink-0" style={{backgroundColor: '#e51c22'}}></span>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-gray-300 hover:text-red-600 transition-colors text-sm flex items-center">
                  <span className="w-2 h-2 rounded-full mr-3 flex-shrink-0" style={{backgroundColor: '#e51c22'}}></span>
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Champions Classic Logo */}
          <div className="lg:col-span-1">
            <div className="flex justify-center lg:justify-start">
              <img 
                src={`${process.env.PUBLIC_URL}/assets/ChampionsClassicLogo-Final-White.png`} 
                alt="Champions Classic Logo" 
                className="w-40 h-40 object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright Section */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              Copyright © 2026. Crash Champions. CC Events. All Rights Reserved.
            </p>
            <div className="flex space-x-8 text-sm">
              <a href="https://xplorpay.com/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-600 transition-colors">
                Payments by Xplor
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;